import { api } from '@/api/client';
import { env } from '@/lib';
import type { InboxResponse, InboxQueryParams } from '../types';

// The notification service (notifyd) lives on its own origin, but authenticates with the same
// auth_token cookie, so it rides the shared api client with nothing but the base url swapped
const notifyOptions = { baseUrl: env.notificationApiBaseUrl };

export async function fetchInbox(params: InboxQueryParams = {}): Promise<InboxResponse> {
  return api.get<InboxResponse>('/v1/inbox', { ...notifyOptions, params });
}

export async function markNotificationRead(id: string): Promise<void> {
  return api.post(`/v1/inbox/${id}/read`, undefined, notifyOptions);
}

// Soft delete — the notification leaves the feed for good, unlike archiving
export async function deleteNotification(id: string): Promise<void> {
  return api.delete(`/v1/inbox/${id}`, undefined, notifyOptions);
}
